import React, { useEffect, useState } from 'react';

interface PhotoExportRedirectProps {
  match: {
    params: {
      exportId: string;
    };
  };
}

const PhotoExportRedirect: React.FC<PhotoExportRedirectProps> = ({ match }) => {
  const [status, setStatus] = useState<'preparing' | 'redirecting' | 'success'>('preparing');

  useEffect(() => {
    const exportId = match.params.exportId;
    const apiBaseUrl = import.meta.env.VITE_APP_API_URL;
    
    // Ensure the base URL has a trailing slash for URL constructor
    const baseUrlWithSlash = apiBaseUrl.endsWith('/') ? apiBaseUrl : `${apiBaseUrl}/`;
    const downloadUrl = new URL(`photo-exports/${exportId}/download`, baseUrlWithSlash);
    
    console.log(`Photo export redirect - Export ID: ${exportId}`);
    console.log(`Photo export redirect - Redirecting to: ${downloadUrl.toString()}`);
    
    // Show redirecting state
    setStatus('redirecting');
    
    // Redirect after a brief delay to show status
    setTimeout(() => {
      window.location.href = downloadUrl.toString();
      setStatus('success');
    }, 1000);
  }, [match.params.exportId]);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '60vh',
      padding: '2rem'
    }}>
      {status === 'preparing' && (
        <>
          <div style={{
            width: '48px',
            height: '48px',
            border: '3px solid #f3f4f6',
            borderTop: '3px solid #8b5cf6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '1.5rem'
          }} />
          <p style={{ fontSize: '1.1rem', color: '#6b7280', margin: 0 }}>
            Preparing your download...
          </p>
        </>
      )}
      {status === 'redirecting' && (
        <>
          <div style={{
            width: '48px',
            height: '48px',
            border: '3px solid #f3f4f6',
            borderTop: '3px solid #10b981',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            marginBottom: '1.5rem'
          }} />
          <p style={{ fontSize: '1.1rem', color: '#6b7280', margin: 0 }}>
            Redirecting to download...
          </p>
        </>
      )}
      {status === 'success' && (
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '48px',
            height: '48px',
            backgroundColor: '#10b981',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '1.5rem',
            margin: '0 auto 1.5rem auto'
          }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <p style={{ fontSize: '1.1rem', color: '#374151', marginBottom: '0.5rem' }}>
            Download should start automatically.
          </p>
          <p style={{ fontSize: '0.9rem', color: '#9ca3af', margin: 0 }}>
            If it doesn't, please check your downloads folder or try again.
          </p>
        </div>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default PhotoExportRedirect;